/**
 * Source policy shared by native-shell entry points.
 */

const DISC_KINDS = new Set(['dvd', 'bluray']);

function hasIsoExt(value) {
  if (!value) return false;
  const clean = String(value).split(/[?#]/, 1)[0].toLowerCase();
  return clean.endsWith('.iso');
}

function queryPathHasIsoExt(value) {
  if (!value) return false;
  try {
    const url = new URL(String(value), globalThis.location?.origin || 'http://127.0.0.1');
    return hasIsoExt(url.searchParams.get('path'));
  } catch {
    return false;
  }
}

export function isDiscImageSource(opts = {}) {
  const kind = String(opts.kind || '').toLowerCase();
  if (DISC_KINDS.has(kind)) return true;

  const ext = String(opts.ext || '').toLowerCase().replace(/^\./, '');
  if (ext === 'iso') return true;

  return hasIsoExt(opts.path)
      || hasIsoExt(opts.directUrl)
      || hasIsoExt(opts.streamUrl)
      || hasIsoExt(opts.url)
      || queryPathHasIsoExt(opts.streamUrl)
      || queryPathHasIsoExt(opts.url);
}

export function nativeInitialSourceMode(opts = {}) {
  return isDiscImageSource(opts) ? 'stream' : 'direct';
}
